import { render } from "./SubtitleDisplay.vue?vue&type=template&id=328b0534&scoped=true"
import script from "./SubtitleDisplay.vue?vue&type=script&lang=js"
export * from "./SubtitleDisplay.vue?vue&type=script&lang=js"

import "./SubtitleDisplay.vue?vue&type=style&index=0&id=328b0534&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328b0534"]])

export default __exports__